import { render } from "./CapabilityStart.vue?vue&type=template&id=a69191b2"
import script from "./CapabilityStart.vue?vue&type=script&lang=js"
export * from "./CapabilityStart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ThinleyNorbu\\source\\repos\\1185_BF_Module_0\\vueOktaVersion\\custom-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__